import {
  IconButton,
  Form,
  ButtonToolbar,
  Button,
  Message,
  Loader
} from 'rsuite';
import provisionImg from '../../images/organization/provision.png';
import serviceTermPdf from '/SD-CloudServices-FortiSOAR.pdf';
import { useNavigate, useParams } from 'react-router-dom';
import {
  AdomVersionSelector,
  ImageVersionSelector,
  ProvisionConfirm,
  RegionSelector,
  TimezoneSelector,
  globalApi,
  useAppDispatch,
  useAppSelector,
  useLazyGetEntitlementsQuery,
  useProvisionMutation
} from '@monorepo/shared';
import { useTranslation } from 'react-i18next';
import { useCallback, useEffect, useState } from 'react';
import { ProvisionCols, server } from '../../config/const';
import { FaStarOfLife } from 'react-icons/fa';
import { selectCurrentAccount } from '@monorepo/shared/store/accountSlice';
import { ProvisionDetail } from './ProvisionStatus';

export const ProvisionButton = () => {
  const navigate = useNavigate();
  return (
    <div className="grid-item">
      <div className="grid-header">
        <div className="title">
          <i className="icon-fortinetone-productViewIcon"></i>
          Provision Cloud Service
        </div>
      </div>
      <div className="grid-content">
        <div
          className="provision-container"
          style={{ height: '100%', display: 'grid', placeItems: 'center' }}
        >
          <IconButton
            onClick={() => {
              navigate('provision');
            }}
            icon={<img src={provisionImg} style={{ width: '85%' }}></img>}
            appearance="link"
          />
        </div>
      </div>
    </div>
  );
};
export const ProvisionForm = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { accountId, sn, regionId } = useParams();
  const [taskObj, setTaskObj] = useState<Record<string, any>>({});
  const [isCheck, setIsCheck] = useState<boolean>(false);
  const navigate = useNavigate();
  const [getEntitlements] = useLazyGetEntitlementsQuery();
  const currentAccount = useAppSelector(selectCurrentAccount);
  const [region, setRegion] = useState<Record<string, any>>({
    rawValue: '',
    label: ''
  });
  const [showImageVersion, setShowImageVersion] = useState<boolean>(true);
  const [showAdomVersion, setShowAdomVersion] = useState<boolean>(false);
  const [imageVersion, setImageVersion] = useState<string>('');
  const [adomVersion, setAdomVersion] = useState<string>('');
  const [timezone, setTimezone] = useState<Record<string, any>>({
    label: '',
    rawValue: ''
  });
  const setSelectedRegion = (selectedItem?: Record<string, any>) => {
    setShowImageVersion(selectedItem?.enableImageVersion);
    setShowAdomVersion(selectedItem?.enableAdomVersion);
    !selectedItem?.enableImageVersion && setImageVersion('');
    selectedItem && setRegion(selectedItem);
  };

  const setSelectedImageVersion = (selectedValue?: string) => {
    setImageVersion(selectedValue || '');
  };

  const setSelectedAdomVersion = (selectedValue?: string) => {
    setAdomVersion(selectedValue || '');
  };
  const setSelectedTimezone = (selectedItem?: Record<string, any>) => {
    selectedItem && setTimezone(selectedItem);
  };
  const [message, setMessage] = useState<string>('');
  const [showMessage, setShowMessage] = useState<boolean>(false);
  const [provisionInstance, getTaskIdResult] = useProvisionMutation();
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const getRequiredProps = useCallback(() => {
    const obj: Record<string, any> = {
      region: {
        value: region?.rawValue,
        errorMessage: `${t('common.provision.regionRequire')}`
      }
    };
    if (ProvisionCols.includes('timezone')) {
      return {
        ...obj,
        timezone: {
          value: timezone?.rawValue,
          errorMessage: `${t('common.provision.timezoneRequire')}`
        }
      };
    }
    return obj;
  }, [timezone, region]);
  const checkError = useCallback(() => {
    setMessage('');
    const messages: Array<string> = [];
    const requiredProps: Record<string, any> = getRequiredProps();
    Object.values(requiredProps).map((obj) => {
      if (!obj?.value) {
        messages.push(obj?.errorMessage);
      }
    });
    if (messages.length) {
      setShowMessage(true);
      setMessage(messages.join('|'));
    } else {
      setShowMessage(false);
      setDialogOpen(true);
    }
  }, [getRequiredProps]);

  useEffect(() => {
    if (getTaskIdResult.error) {
      const data: Record<string, any> = getTaskIdResult.error;
      const code = data?.data?.error_code || data?.status;
      const message = data?.data?.error_desc || data?.data?.message;
      if (message && setMessage) {
        setMessage(`${message} [Error_code: ${code}]`);
        setShowMessage(true);
      }
    } else if (getTaskIdResult.data) {
      const data: Record<string, any> = getTaskIdResult.data;
      if (data?.task_id) {
        getEntitlements({
          server: server,
          accountId: currentAccount.account_id
        });
        // navigate(-1);
        setTaskObj({ task_id: data.task_id, region_alias: region.rawValue });
      } else if (data?.login_url) {
        console.warn('This instance already has url exists', data?.login_url);
        setMessage(
          'This license SN already provisioned. Login url : ' + data?.login_url
        );
        setShowMessage(true);
      } else if (data?.error_desc && setMessage) {
        setMessage(`${data?.error_desc} [Error_code: ${data?.error_code}]`);
        setShowMessage(true);
      }
    }
  }, [getTaskIdResult]);

  useEffect(() => {
    if (sn && regionId) {
      setIsCheck(true);
    } else if (taskObj.task_id && taskObj.region_alias) {
      setIsCheck(true);
    } else {
      setIsCheck(false);
    }
  }, [regionId, taskObj, sn]);

  return (
    <div className="account-provision-container">
      {getTaskIdResult.isLoading ? (
        <div style={{ height: '90%', position: 'relative' }}>
          <Loader center size="md" />
        </div>
      ) : isCheck ? (
        <ProvisionDetail
          sn={sn === 'trial' ? undefined : sn}
          task_id={taskObj.task_id}
          account_id={currentAccount?.account_id}
          region_alias={regionId || taskObj.region_alias}
        ></ProvisionDetail>
      ) : (
        <>
          {showMessage ? (
            <Message
              showIcon
              type="error"
              header="A problem occurred:"
              style={{ marginBottom: '20px' }}
            >
              <ul>
                {message.split('|')?.map((str: string, index: number) => (
                  <li key={index}>{str}</li>
                ))}
              </ul>
            </Message>
          ) : (
            <></>
          )}
          <Form fluid formValue={{ sn: sn }}>
            {ProvisionCols.includes('sn') && sn !== 'trial' ? (
              <Form.Group controlId="sn" aria-required>
                <Form.ControlLabel>License SN</Form.ControlLabel>
                <Form.Control name="sn" readOnly />
              </Form.Group>
            ) : (
              <></>
            )}
            <Form.Group controlId="region" aria-required>
              <Form.ControlLabel>
                {t('common.provision.region')} <RequiredIcon />
              </Form.ControlLabel>
              <div className={'rs-form-control-wrapper'}>
                <RegionSelector
                  onSelectHandle={setSelectedRegion}
                  server={server}
                />
              </div>
            </Form.Group>
            {/* {ProvisionCols.includes('timezone') ? (
              <Form.Group controlId="timezone">
                <Form.ControlLabel>
                  {t('common.provision.timezone')}
                  <RequiredIcon />
                </Form.ControlLabel>
                <div className={'rs-form-control-wrapper'}>
                  <TimezoneSelector
                    region={region?.rawValue}
                    onSelectHandle={setSelectedTimezone}
                  />
                </div>
              </Form.Group>
            ) : (
              <></>
            )}
            <Form.Group
              controlId="image-version"
              style={{
                visibility: `${
                  showImageVersion && region?.rawValue ? 'visible' : 'hidden'
                }`
              }}
            >
              <Form.ControlLabel>
                {t('common.provision.imageVersion')}
              </Form.ControlLabel>
              <div className={'rs-form-control-wrapper'}>
                <ImageVersionSelector
                  region={region?.rawValue}
                  onSelectHandle={setSelectedImageVersion}
                />
              </div>
            </Form.Group>
            {ProvisionCols.includes('adom-version') ? (
              <Form.Group
                controlId="adom-version"
                style={{
                  visibility: `${
                    showAdomVersion && imageVersion ? 'visible' : 'hidden'
                  }`
                }}
              >
                <Form.ControlLabel>
                  {t('common.provision.adomVersion')}
                </Form.ControlLabel>
                <div className={'rs-form-control-wrapper'}>
                  <AdomVersionSelector
                    imageVersion={imageVersion}
                    onSelectHandle={setSelectedAdomVersion}
                  />
                </div>
              </Form.Group>
            ) : (
              <></>
            )} */}
            <ButtonToolbar>
              <Button
                appearance="ghost"
                className="action-btn"
                onClick={() => {
                  dispatch(globalApi.util.invalidateTags(['Entitlements']));
                  navigate(-1);
                }}
              >
                Cancel
              </Button>
              <Button
                appearance="primary"
                className="action-btn"
                onClick={checkError}
              >
                {t('common.provision.submit')}
              </Button>
            </ButtonToolbar>
          </Form>
          <ProvisionConfirm
            requiredProps={getRequiredProps()}
            dialogOpen={dialogOpen}
            setDialogOpen={setDialogOpen}
            rowData={{ account_id: currentAccount.account_id }}
            timezone={timezone}
            region={region}
            imageVersion={imageVersion}
            adomVersion={adomVersion}
            provisionInstance={provisionInstance}
            pdf={serviceTermPdf}
            server={server}
            sn={sn === 'trial' ? undefined : sn}
            is_trial={sn === 'trial'}
          ></ProvisionConfirm>
        </>
      )}
    </div>
  );
};

export const RequiredIcon = () => {
  return (
    <FaStarOfLife
      style={{ color: 'red', fontSize: '0.5em', verticalAlign: 'top' }}
    />
  );
};
